<template>
  <div>
     <vue-element-loading :active="appLoading" :is-full-screen="true"/>
    <div class="pt-12 mt-4">
      <v-layout wrap>
        <v-flex xs12>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3612.503294103132!2d55.21131131451769!3d25.118669983932676!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6bc2a1128811%3A0x487ee38270b66a55!2sAL%20SADEEL%20ELECTROMECHNICAL%20WORKS%20(L.L.C)!5e0!3m2!1sen!2sin!4v1606976337490!5m2!1sen!2sin"
            width="100%"
            height="400"
            frameborder="0"
            style="border: 0"
            allowfullscreen=""    
            aria-hidden="false"
            tabindex="0"
          ></iframe>
          <v-divider></v-divider>
        </v-flex>
      </v-layout>
    </div>
    <v-snackbar v-if="snackbar" v-model="snackbar" >
      <span style="color: white"> {{ message }}</span>

      <template v-slot:action="{ attrs }">
        <v-btn color="indigo" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <div>
      <v-layout py-5 wrap>
        <v-flex xs11 offset-xs1 lg12>
          <v-layout wrap>
            <v-flex xs12 lg5>
              <v-layout wrap>
                <v-flex xs12 lg12>
                  <span
                    style="
                      padding-left: 10px;
                      font-family: poppinsbold;
                      color: #e7ab5f;
                      font-size: 28px;
                    "
                  >
                    Contact US
                  </span>
                </v-flex>
              </v-layout>
              <v-layout pl-3 wrap>
                <v-flex xs12>
                  <v-layout v-if="contactUs.country" pt-1 pl-1 wrap>
                    <v-flex xs10 lg11>
                      <span
                        style="font-family: poppinssemibold; font-size: 18px"
                      >
                        {{ contactUs.country }}
                      </span>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="contactUs.address" wrap>
                    <v-flex xs12 lg8>
                      <v-icon color=" #4d4d4d">mdi-google-maps</v-icon>

                      <span
                        style="
                          padding-left: 10px;
                          font-family: poppinsregular;
                          font-size: 14px;
                          letter-spacing: 2px;
                        "
                      >
                        {{ contactUs.address }}
                      </span>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="contactUs.phone" wrap>
                    <v-flex xs6 lg3>
                      <v-icon color=" #4d4d4d">mdi-phone-classic</v-icon>
                      <span
                        style="
                          padding-left: 10px;
                          font-family: poppinsregular;
                          font-size: 14px;
                        "
                      >
                        Telephone :
                      </span>
                    </v-flex>
                    <v-flex xs6 lg3>
                      <span
                        style="
                          padding-left: 10px;
                          font-family: poppinsregular;
                          font-size: 14px;
                        "
                      >
                        {{ contactUs.phone }}
                      </span>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="contactUs.fax" wrap>
                    <v-flex xs6 lg3>
                      <v-icon color=" #4d4d4d">mdi-fax</v-icon>
                      <span
                        style="
                          padding-left: 10px;
                          font-family: poppinsregular;
                          font-size: 14px;
                        "
                      >
                        Fax :
                      </span>
                    </v-flex>
                    <v-flex xs6 lg3>
                      <span
                        style="
                          padding-left: 10px;
                          font-family: poppinsregular;
                          font-size: 14px;
                        "
                      >
                        {{ contactUs.fax }}
                      </span>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="contactUs.mobile" wrap>
                    <v-flex xs6 lg3>
                      <v-icon color=" #4d4d4d">mdi-cellphone-iphone</v-icon>
                      <span
                        style="
                          padding-left: 10px;
                          font-family: poppinsregular;
                          font-size: 14px;
                        "
                      >
                        Mobile :
                      </span>
                    </v-flex>
                    <v-flex xs6 lg3>
                      <span
                        style="
                          padding-left: 10px;
                          font-family: poppinsregular;
                          font-size: 14px;
                        "
                      >
                        {{ contactUs.mobile }}
                      </span>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="contactUs.email" wrap>
                    <v-flex xs6 lg3>
                      <v-icon color=" #4d4d4d">mdi-email</v-icon>
                      <span
                        style="
                          padding-left: 10px;
                          font-family: poppinsregular;
                          font-size: 14px;
                        "
                      >
                        Email :
                      </span>
                      
                    </v-flex>
                    <v-flex xs6 lg3>
                       <a style="text-decoration:none;color:#000000" :href="'mailto:'+contactUs.email">

                      <span
                        style="
                          padding-left: 10px;
                          font-family: poppinsregular;
                          font-size: 14px;
                        "
                      >
                        {{ contactUs.email }}
                      </span>
                       </a>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex pr-5 xs12 lg7>
              <v-tabs
                v-model="tab"
                background-color="transparent"
                color="#e7ab5f"
                grow
              >
                <v-tab style="font-family: poppinsregular; font-size: 14px;"> Contact Form </v-tab>
                <v-tab  style="font-family: poppinsregular; font-size: 14px;"> Complaint Form </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-form ref="form" lazy-validation>
                    <v-layout pt-2 wrap>
                      <v-flex xs12>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-text-field
                              v-model="contactForm.fullName"
                              :rules="nameRules"
                              outlined  style="font-family: poppinsregular; font-size: 14px;"
                              dense
                              placeholder="Full Name"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout wrap>
                          <v-flex xs12>
                            <v-text-field
                              v-model="contactForm.customerName"
                              :rules="nameRules"
                              outlined
                               style="font-family: poppinsregular; font-size: 14px;"
                              dense
                              placeholder="Customer Name"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-text-field
                              v-model="contactForm.email"
                              :rules="emailRules"
                              outlined
                              dense
                               style="font-family: poppinsregular; font-size: 14px;"
                              placeholder="Email Address"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-textarea
                              v-model="contactForm.message"
                              outlined  style="font-family: poppinsregular; font-size: 14px;"
                              dense
                              rows="3"
                              placeholder="Message"
                            ></v-textarea>
                          </v-flex>
                        </v-layout>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-btn @click="validate('contact')" color="success"
                              >Submit</v-btn
                            >
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-tab-item>
                <v-tab-item>
                  <v-form ref="form1" lazy-validation>
                    <v-layout pt-2 wrap>
                      <v-flex xs12>
                        <v-layout wrap>
                          <v-flex xs12 lg5>
                            <span
                              style="
                                padding-left: 10px;
                                font-family: poppinssemibold;
                                font-size: 14px;
                              "
                            >
                              Customer Type
                            </span>
                            <v-select
                              outlined  style="font-family: poppinsregular; font-size: 14px;"
                              v-model="complaintForm.customerType"
                              :rules="requiredRules"
                              dense
                              :items="customerTypeArray"
                              placeholder="Customer Type"
                            ></v-select>
                          </v-flex>
                          <v-flex lg1> </v-flex>
                          <v-flex xs12 lg6>
                            <span
                              style="
                                padding-left: 10px;
                                font-family: poppinssemibold;
                                font-size: 14px;
                              "
                            >
                              Customer Name
                            </span>
                            <v-text-field
                             :rules="nameRules"
                              v-model="complaintForm.customerName"
                              outlined  style="font-family: poppinsregular; font-size: 14px;"
                              dense
                              placeholder="Customer Name"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout wrap>
                          <v-flex xs12 lg5>
                            <span
                              style="
                                padding-left: 10px;
                                font-family: poppinssemibold;
                                font-size: 14px;
                              "
                            >
                              Mobile Number
                            </span>
                            <v-text-field
                              v-model="complaintForm.mobile"
                              :rules="requiredRules"
                              type="number"
                              outlined  style="font-family: poppinsregular; font-size: 14px;"
                              dense
                              placeholder="Use country code with number"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg1> </v-flex>
                          <v-flex xs12 lg6>
                            <span
                              style="
                                padding-left: 10px;
                                font-family: poppinssemibold;
                                font-size: 14px;
                              "
                            >
                              Telephone Number
                            </span>
                            <v-text-field
                              v-model="complaintForm.phone"
                              type="number"
                              outlined  style="font-family: poppinsregular; font-size: 14px;"
                              dense
                              placeholder="Use country code with number"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout wrap>
                          <v-flex xs12 lg5>
                            <span
                              style="
                                padding-left: 10px;
                                font-family: poppinssemibold;
                                font-size: 14px;
                              "
                            >
                              Email
                            </span>
                            <v-text-field
                              v-model="complaintForm.email"
                              :rules="emailRules"
                              outlined  style="font-family: poppinsregular; font-size: 14px;"
                              dense
                              placeholder="Email Address"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg1> </v-flex>
                          <v-flex xs12 lg6>
                            <span
                              style="
                                padding-left: 10px;
                                font-family: poppinssemibold;
                                font-size: 14px;
                              "
                            >
                              Complaint Type
                            </span>
                            <v-select
                              outlined  style="font-family: poppinsregular; font-size: 14px;"
                              dense
                              v-model="complaintForm.complaintType"
                              :items="services"
                              item-text="name"
                              item-value="name"
                              placeholder="Complaint Type"
                            ></v-select>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-space-between wrap>
                          <v-flex xs12 lg5>
                            <span
                              style="
                                padding-left: 10px;
                                font-family: poppinssemibold;
                                font-size: 14px;
                              "
                            >
                              Address
                            </span>
                            <v-textarea
                              v-model="complaintForm.address"
                              outlined  style="font-family: poppinsregular; font-size: 14px;"
                              dense
                              rows="3"
                              placeholder="Address"
                            ></v-textarea>
                          </v-flex>
                          <!-- </v-layout>
                      
                      <v-layout wrap> -->
                          <v-flex xs12 lg6>
                            <span
                              style="
                                padding-left: 10px;
                                font-family: poppinssemibold;
                                font-size: 14px;
                              "
                            >
                              Complaint in Detail
                            </span>
                            <v-textarea
                              v-model="complaintForm.complaintDetails"
                              outlined  style="font-family: poppinsregular; font-size: 14px;"
                              dense
                              rows="3"
                              placeholder="Complaint"
                            ></v-textarea>
                          </v-flex>
                        </v-layout>
                        <v-layout wrap>
                          <v-flex xs12>
                            <span
                              style="
                                padding-left: 10px;
                                font-family: poppinssemibold;
                                font-size: 14px;
                              "
                            >
                              Date & time you prefer to get your complaint
                              solved
                            </span>
                            <datetime
                              type="datetime"
                              v-model="dateTimeValue"
                              input-class="my-class"
                              :phrases="{ ok: 'Continue', cancel: 'Exit' }"
                              :hour-step="2"
                              :minute-step="15"
                              :week-start="7"
                              use12-hour
                              auto
                            >
                            </datetime>
                          </v-flex>
                        </v-layout>
                        <v-layout wrap>
                          <v-flex pt-4 xs12>
                            <v-btn @click="validate('complaint')" color="success">Submit</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-tab-item>
              </v-tabs-items>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
import "vue-datetime/dist/vue-datetime.css";
import axios from "axios";
export default {
  data() {
    return {
      contactUs: [],
      snackbar: false,
      appLoading:false,
      message: null,
      nameRules: [
        (v) => !!v || "Name is required",
        // v => (v && v.length <= 10) || 'Name must be less than 50 characters',
      ],
      requiredRules: [
        (v) => !!v || "Required Field",
        // v => (v && v.length <= 10) || 'Name must be less than 50 characters',
      ],

      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      contactForm: {
        fullName: null,
        customerName: null,
        email: null,
        message: null,
      },
      complaintForm: {
        customerType: null,
        customerName: null,
        mobile: null,
        phone: null,
        email: null,
        complaintType: null,
        address: null,
        complaintDetails: null,
        expectedSolveTime: null,
      },
      services: [],
      dateTimeValue: null,
      minDatetime: new Date().toISOString().slice(0, 10),

      tab: null,
      customerTypeArray: ["Residential", "Commercial", "Industrial"],
      // complaintTypeArray: [
      //   "Electrical Service",
      //   "Plumbing Service",
      //   "Air Condition Service",
      //   "Other",
      // ],
    };
  },
  mounted() {
    this.getServices();
    this.getContactUs();
  },
  methods: {
    validate(val) {
      if (val == "contact") {
        if (this.$refs.form.validate()) this.contactQuery();
      } else if (val == "complaint")
        if (this.$refs.form1.validate()) this.complaintQuery();
    },
    contactQuery() {
      this.appLoading=true
      axios({
        method: "POST",
        url: "/contact/form/add",
        data: this.contactForm,
      })
        .then((response) => {
          if (response.data.status) {
             this.appLoading=false
            this.$refs.form.reset();
            this.snackbar = true;
            this.message = response.data.msg;
          }
          else{
             this.appLoading=false
          }
        })
        .catch(() => {
           this.appLoading=false
        });
    },
     complaintQuery() {
       console.log(this.dateTimeValue,'hh')
       var val2=this.formatDate(this.dateTimeValue)
       this.complaintForm.expectedSolveTime=val2
        this.appLoading=true
      axios({
        method: "POST",
        url: "/complaint/form/add",
        data: this.complaintForm,
      })
        .then((response) => {
          if (response.data.status) {
             this.appLoading=false
            this.$refs.form1.reset();
            this.dateTimeValue=null
            this.snackbar = true;
            this.message = response.data.msg;
          }
          else
           this.appLoading=false
        })
        .catch(() => {
           this.appLoading=false
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes()
      dt = dt.toString();
      // if (minutes >= 60) {
      //   hours = hours + 1;
      //   minutes = minutes - 60;
      // }
      var ampm = hours >= 12 ? "pm" : "am";

      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
    getServices() {
      axios({
        method: "GET",
        url: "/service/providers/list",
      })
        .then((response) => {
          if (response.data.status) this.services = response.data.data;
        })
        .catch(() => {});
    },
    getContactUs() {
      axios({
        method: "GET",
        url: "/contactus/view",
      })
        .then((response) => {
          if (response.data.status) this.contactUs = response.data.data;
        })
        .catch(() => {});
    },
  },
};
</script>
<style >
.vdatetime-input {
  border-radius: 0px !important;
  border-style: groove !important;
  border-width: 1px !important;
  width: 100% !important;
  line-height: 32px !important;
  height: 38px !important;
  border-color: #000000;
  padding-left: 10px;
}
</style>